/*
export function useReturnRoute() {
  defineProps<{ returnRoute: ReturnRouteProp | null }>();
}*/
export default {
    props: {
        returnRoute: {
            type: Object,
            default: null
        }
    }
};
export const returnRouteProps = {
    returnRoute: {
        type: Object,
        default: null
    }
};
